<template>
    <div class="pop_overay">
        <div class="pop_cont">
            <img class="icon_img" src="@/assets/images/popup_icon.png" alt="icon">
            <div class="text_2">
                <div class="noti_txt">
                  <div v-html="popupNoti.tit1"></div>
                  <span v-if="popupNoti.tit2">{{popupNoti.tit2}}</span>
                </div>
            </div>
            <button :class="(popupNoti.tit2 || popupNoti.tit3) ? 'type1' : ''" @click="closeBtn">닫기</button>
            <button class="type2" v-if="popupNoti.tit2" @click="receiveInfo">계정정보 입력</button>
            <button class="type2" v-if="popupNoti.tit3" @click="surveyLink">설문 참여하기</button>
        </div>
    </div>
</template>
<script>
// import * as appEvent from '@/assets/js/app_event.js'
import { mapState } from 'vuex'
export default {
  name: 'PopupGiftPop',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['popupNoti'])
  },
  methods: {
    closeBtn () {
      if (this.popupNoti.close === 'Y') {
        this.$store.dispatch('openPopupGift', {})
      }
      this.$store.dispatch('openNotiPopup', {})
    },
    receiveInfo () {
      location.href = 'https://m.tranggle.com/mingle/intro/total_account_setting'
    },
    surveyLink () {
      this.closeBtn()
      // const url = 'https://docs.google.com/forms/d/e/1FAIpQLSf38B5SSZLAZCbGdvr2WysBRF8JD_xFDffN1QXl6gzm5eGLEQ/viewform'
      // appEvent.externalLinks(url)
      this.$router.push('/survey/view1')
    }
  },
  mounted () {
  }
}
</script>
